import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AdmittedProvider } from "../../context/AdmittedContext";
import AdmittedPanel from "./AdmittedPanel";

const AdmittedPage = () => {
  const { t } = useTranslation();

  return (
    <AdmittedProvider>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
          {t("nav.admitted", "Admitted")}
        </Typography>
        <AdmittedPanel />
      </Box>
    </AdmittedProvider>
  );
};

export default AdmittedPage;
